import Search from "../Search/Search";
import { ReactComponent as PlusIcon } from "../../../assets/icons/Plus.svg";
import ExcelExportBtn from "../../ExcelExportBtn/ExcelExportBtn";
import { DatePick } from "../../DatePicker/DatePicker";
import { useLocation } from "react-router-dom";
import { CoursesDropdown } from "../CoursesDropdown/CoursesDropdown";

const QuarterlyTargetPlanPageHead = ({
  openModal,
  search,
  filter,
  searchData,
  dataSearchValues,
  DATA_SEARCH_VALUE,
}) => {
  const location = useLocation();

  return (
    <div style={{ width: "100%" }}>
      <div className="teacher-page-add-btn"></div>
      <div style={{ display: "flex", gap: "10px" }}>
        <DatePick deviceType="desktop" />

        <CoursesDropdown deviceType="desktop" />

        <div className="lesson-table-btn-container teacher ">
          <button className="add-detail" onClick={() => filter()}>
            Tətbiq et
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuarterlyTargetPlanPageHead;
